import angular from 'angular';
import isFeelingStuck from './isFeelingStuck';

export default angular
  .module('components.isFeelingStuck', [])
  .component('isFeelingStuck', isFeelingStuck).name;
